﻿export default class NavigationList {
    constructor(vm) {
        this.vm = vm;
    }

    get(event) {
        let trackingObject = null;

        switch (event) {
            case 'navigation-list-load':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Listemodul',
                    'eventAction': 'impression',
                    'eventLabel': 'Listemodul' + (this.vm !== '' ? ' - ' + this.vm : ''),
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
            case 'navigation-list-click-element':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Listemodul',
                    'eventAction': 'click',
                    'eventLabel': 'Listemodul' + (this.vm.description !== '' ? ' - ' + this.vm.description : '') + ' - ' + this.vm.label,
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
            case 'navigation-list-click-overview-element':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Listemodul',
                    'eventAction': 'overview - click',
                    'eventLabel': this.vm.label,
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
        }

        return trackingObject;
    }
}
